import { TextField, Fab } from "@material-ui/core";
import React, { useState } from "react";

const LoginForm = (props) => {
  const [data, setData] = useState({
    email: "",
    password: "",
    remember: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    props.handleSubmit(data);
  };

  return (
    <form
      className="space-y-6"
      onSubmit={handleSubmit}
      style={{ marginTop: 20, width: "100%" }}
    >
      <div>
        <label
          htmlFor="email"
          className="block text-sm font-medium leading-5 text-gray-700"
        >
          Username or Email address
        </label>
        <div className="mt-1 rounded-md shadow-sm">
          <TextField
            id="text"
            type="text"
            value={data.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
            required
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          />
        </div>
      </div>
      <div>
        <label
          htmlFor="password"
          className="block text-sm font-medium leading-5 text-gray-700"
        >
          Password
        </label>
        <div className="mt-1 rounded-md shadow-sm">
          <TextField
            id="password"
            type="password"
            value={data.password}
            onChange={(e) => setData({ ...data, password: e.target.value })}
            required
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          />
        </div>
      </div>
      <div className="flex items-center justify-between">
        {/* <div className="flex items-center">
          <TextField
            id="remember_me"
            type="checkbox"
            className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
          />
          <label
            htmlFor="remember_me"
            className="ml-2 block text-sm leading-5 text-gray-900"
          >
            Remember me
          </label>
        </div> */}
        <div className="text-sm leading-5">
          <a href="#" style={{ fontSize: 15 }}>
            Forgot your password?
          </a>
        </div>
      </div>
      <div>
        <Fab
          variant="extended"
          color="primary"
          aria-label="add new date"
          type="submit"
          style={{ marginTop: 15, marginBottom: 15, padding: "15px 30px" }}
        >
          Sign in
        </Fab>
      </div>
    </form>
  );
};
export default LoginForm;
